import { Link } from "react-router-dom";

import { SafetyCertificateOutlined, SettingOutlined } from "@ant-design/icons";

const navigation = [
  { name: "General", href: "/settings", icon: SettingOutlined, current: true },
  {
    name: "Security",
    href: "/security",
    icon: SafetyCertificateOutlined,
    current: false,
  },
];

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export default function VNavWithIcon({ currentPage }: any) {
  return (
    <nav className="space-y-1" aria-label="Sidebar">
      {navigation.map((item) => (
        <Link
          key={item.name}
          to={item.href}
          className={classNames(
            currentPage === item.href
              ? "bg-gray-100 text-gray-900"
              : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
            "group flex items-center rounded-md px-8 py-2 text-sm font-medium"
          )}
          aria-current={item.current ? "page" : undefined}
        >
          <div
            className={classNames(
              currentPage === item.href
                ? "text-gray-900"
                : "text-gray-400 group-hover:text-gray-500",
              "mr-3 flex-shrink-0"
            )}
          >
            <item.icon style={{ fontSize: 26 }} />
          </div>
          <span className="truncate">{item.name}</span>
        </Link>
      ))}
    </nav>
  );
}
